


















































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import { queryDrawPrizeById, addDrawPrize, editDrawPrize } from '@/api/drawPrize'
import { baseUrl } from '@/config.json'

interface PrizeForm {
  name: string;
  image: string;
  description: string;
  price: string;
  status: number;
  originalPrice: string;
  id: string;
  [key: string]: any;
}

@Component({
  name: 'addPrize',
  components: {
    HeadLable,
    ImageUpload
  }
})
export default class extends Vue {
  private imageUrl: string = ''
  private actionType: string = ''
  private ruleForm: PrizeForm = {
    name: '',
    image: '',
    description: '',
    price: '',
    status: 1,
    originalPrice: '',
    id: ''
  }

  get rules() {
    return {
      name: {
        required: true,
        validator: (rule: any, value: string, callback: Function) => {
          if (!value) {
            callback(new Error('请输入奖品名称'))
          } else {
            const reg = /^([A-Za-z0-9\u4e00-\u9fa5]){2,20}$/
            if (!reg.test(value)) {
              callback(new Error('奖品名称输入不符，请输入2-20个字符'))
            } else {
              callback()
            }
          }
        },
        trigger: 'blur'
      },
      image: {
        required: true,
        message: '奖品图片不能为空'
      },
      price: {
        validator: (rule: any, value: string, callback: Function) => {
          if (value && !/^\d+(\.\d{1,2})?$/.test(value)) {
            callback(new Error('价格格式不正确，请输入数字，最多两位小数'))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      }
    }
  }

  created() {
    this.actionType = this.$route.query.id ? 'edit' : 'add'
    if (this.actionType == 'edit') {
      this.init()
    }
  }

  private async init() {
    queryDrawPrizeById(this.$route.query.id).then(res => {
      if (res && res.data && res.data.code === 1) {
        const data = res.data.data
        // 手动设置各个字段，确保数据类型正确
        this.ruleForm.id = data.id
        this.ruleForm.name = data.name || ''
        this.ruleForm.description = data.description || ''
        this.ruleForm.image = data.image || ''
        this.ruleForm.status = data.status != null ? Number(data.status) : 1
        // 价格转为字符串显示，保留两位小数
        this.ruleForm.price = data.price != null ? Number(data.price).toFixed(2) : '0.00'
        this.ruleForm.originalPrice = data.originalPrice != null ? Number(data.originalPrice).toFixed(2) : '0.00'
        
        // 设置图片URL
        this.imageUrl = data.image || ''
      }
    })
  }

  // 价格输入验证直接通过表单验证器实现

  // 保存
  private submitForm(formName: string, goAhead: boolean) {
    const form: any = this.$refs[formName]
    form.validate((valid: boolean) => {
      if (valid) {
        const params: any = { ...this.ruleForm }
        // 确保价格是数值类型
        params.price = parseFloat(params.price || '0')
        params.originalPrice = parseFloat(params.originalPrice || '0')
        
        const request = this.actionType === 'add' ? addDrawPrize : editDrawPrize
        request(params)
          .then(res => {
            if (res && res.data && res.data.code === 1) {
              this.$message.success('保存成功！')
              if (goAhead) {
                this.imageUrl = ''
                form.resetFields()
                this.ruleForm = {
                  name: '',
                  image: '',
                  description: '',
                  price: '',
                  status: 1,
                  originalPrice: '',
                  id: ''
                }
              } else {
                this.$router.push('/prize')
              }
            } else {
              this.$message.error(res.data.msg || '操作失败')
            }
          })
          .catch(err => {
            this.$message.error('请求出错了：' + err.message)
          })
      }
    })
  }

  // 图片上传
  private imageChange(url: string) {
    this.ruleForm.image = url
    this.$forceUpdate()
  }
}
